import PropTypes from 'prop-types';
import React from 'react';
import Form from '@rjsf/core';

import { ArrayField, CustomCheckbox, CustomDateTime, CustomFieldTemplate, CustomSelect, ObjectField, BaseInputTemplate, TitleFieldTemplate, DescriptionFieldTemplate } from './JsonSchemaFormComponents';
import { transformErrors, validator } from './JsonSchemaFormHelpers';

const widgets = {
  CheckboxWidget: CustomCheckbox,
  DateTimeWidget: CustomDateTime,
  SelectWidget: CustomSelect,
};

const customFields = {
  ArrayField,
  ObjectField,
}

const templates = {
  FieldTemplate: CustomFieldTemplate,
  BaseInputTemplate,
  TitleFieldTemplate,
  DescriptionFieldTemplate,
};

const defaultUiSchema = {
  'ui:order': ['name', 'config', 'permissions'],
};

function JsonSchemaForm(props) {
  const { 
    schema, 
    data, 
    onSubmit, 
    onChange, 
    uiSchema, 
    submitDisabled, 
    readOnly,
    hideSubmitButton = false,
    formRef
  } = props;
  const submitButtonOptions = uiSchema?.['ui:submitButtonOptions'];
  const resolvedSubmitOptions = (submitButtonOptions || submitDisabled !== undefined || hideSubmitButton)
    ? {
        ...(submitButtonOptions || {}),
        ...(hideSubmitButton ? { norender: true } : {}),
        props: {
          ...(submitButtonOptions?.props || {}),
          ...(submitDisabled !== undefined ? { disabled: submitDisabled } : {}),
        },
      }
    : undefined;
  const resolvedUiSchema = {
    ...(uiSchema || defaultUiSchema),
    ...(resolvedSubmitOptions ? { 'ui:submitButtonOptions': resolvedSubmitOptions } : {}),
  };

  React.useEffect(() => {
    validator.prepareSchema?.(schema);
  }, [schema]);

  return (
    <Form
      ref={formRef}
      schema={schema}
      uiSchema={resolvedUiSchema}
      formData={data}
      validator={validator}
      widgets={widgets}
      fields={customFields}
      templates={templates}
      liveValidate
      onSubmit={onSubmit}
      onChange={onChange}
      transformErrors={transformErrors}
      showErrorList={false}
      disabled={readOnly}
    />
  );
}

JsonSchemaForm.propTypes = {
  schema: PropTypes.object.isRequired,
  data: PropTypes.any,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  uiSchema: PropTypes.object,
  submitDisabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  hideSubmitButton: PropTypes.bool,
  formRef: PropTypes.object,
};

export default JsonSchemaForm;
